import type { GuideSection } from '../types.js';

import overview from './overview.txt';
import materialize from './materialize.txt';
import results from './results.txt';
import classification from './classification.txt';
import history from './history.txt';
import skips from './skips.txt';
import lifecycle from './lifecycle.txt';
import reruns from './reruns.txt';
import reporting from './reporting.txt';

export const EXTERNAL_RUN_GUIDE_SECTIONS: GuideSection[] = [
  { title: 'External run diagnosis overview', slug: 'overview', content: overview },
  { title: 'Materialize a diagnostic workspace', slug: 'materialize', content: materialize },
  { title: 'Read results and attempts', slug: 'results', content: results },
  { title: 'Classify failures', slug: 'classification', content: classification },
  { title: 'Use scenario history', slug: 'history', content: history },
  { title: 'Explain skipped tests', slug: 'skips', content: skips },
  { title: 'Read lifecycle, retries, and timeouts', slug: 'lifecycle', content: lifecycle },
  { title: 'Run controlled reruns', slug: 'reruns', content: reruns },
  { title: 'Write an evidence-backed report', slug: 'reporting', content: reporting },
];
